import React from 'react'
// libs
import { useApolloClient } from 'hooks/useApolloClient'
import { InjectedFormProps, reduxForm } from 'redux-form'
// components
import Field from 'components/Modals/AiLinkedFormsModal/components/RisksSuggestions/components/Field'
import Control from 'components/Modals/AiLinkedFormsModal/components/RisksSuggestions/components/Row/components/Control'
// views
import { Badge, BadgeGroup, OverlayStack, TableCell, TableRow } from 'components/Modals/AiLinkedFormsModal/views'
// types
import { IAiMatchedFilter, IAiSuggestionField, IField } from 'types/graphql'
// utils
import { getFieldsInitialValues } from 'utils/form'

interface Props {
  fieldValues: IAiSuggestionField[]
  currentAction: 'copy' | 'reference' | null
  onButtonClick: (action: 'copy' | 'reference') => void
  matchedFilter?: IAiMatchedFilter
  templateFields: IField[]
  existingRecordId?: string
}

const Row: React.FC<Props & InjectedFormProps<any, Props>> = ({
  initialize,
  fieldValues,
  currentAction,
  onButtonClick,
  matchedFilter,
  templateFields,
  existingRecordId
}) => {
  const isAiGenerated = !existingRecordId
  const { client } = useApolloClient()

  React.useEffect(() => {
    const fetchAndInitialize = async () => {
      const fieldsInitialValues = await getFieldsInitialValues({
        client,
        fields: templateFields,
        fieldValues: fieldValues.map((item) => ({
          fieldName: item.fieldId,
          fieldType: templateFields.find(({ id }) => id === item.fieldId)?.fieldType,
          fieldValue: item.value
        }))
      })

      initialize(fieldsInitialValues)
    }

    fetchAndInitialize()
  }, [])

  return (
    <TableRow>
      {templateFields.map((field) => (
        <TableCell key={field.id}>
          <Field field={field} name={field.name} />
        </TableCell>
      ))}
      <OverlayStack>
        {(isAiGenerated || matchedFilter) && (
          <BadgeGroup>
            {isAiGenerated && <Badge variant='ai'>rAI</Badge>}
            {matchedFilter && <Badge variant='filter'>{matchedFilter.name}</Badge>}
          </BadgeGroup>
        )}
        <Control currentAction={currentAction} onButtonClick={onButtonClick} copyOnly={isAiGenerated} />
      </OverlayStack>
    </TableRow>
  )
}

export default reduxForm<any, Props>({
  enableReinitialize: true
})(Row)
